var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"centralized-issues-tld-table-cell",attrs:{"title":_vm.item.tld}},[_c('span',{staticClass:"centralized-issues-tld-table-cell__tld"},[_vm._v(" "+_vm._s(_vm.item.tld)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }